import { Component } from '@angular/core';

@Component({
  selector: 'product-skeleton-loader',
  templateUrl: './product-skeleton-loader.component.html',
  standalone: false,
})
export class ProductSkeletonLoaderComponent {}
